import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './MenuButton.css';

function MenuButton() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleMenuClick = () => {
    setMenuOpen(!menuOpen);
  };

  const handleDeskSuiteClick = () => {
    setMenuOpen(false);
    navigate('/dashboard');
  };

  const handleDesktopClick = () => {
    setMenuOpen(false);
    navigate('/desktop');
  };

  const handleSettingsClick = () => {
    setMenuOpen(false);
    // Future: navigate to settings
    alert('Settings coming soon!');
  };

  const isOnDesktop = location.pathname === '/desktop';

  // Close menu when clicking outside
  React.useEffect(() => {
    if (menuOpen) {
      const closeMenu = (e) => {
        if (!e.target.closest('.menu-button') && !e.target.closest('.menu-popup')) {
          setMenuOpen(false);
        }
      };
      document.addEventListener('click', closeMenu);
      return () => document.removeEventListener('click', closeMenu);
    }
  }, [menuOpen]);

  return (
    <>
      <button
        className={`menu-button ${menuOpen ? 'active' : ''}`}
        onClick={handleMenuClick}
        title="Menu"
      >
        <div className="menu-icon">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>

      {menuOpen && (
        <div className="menu-popup">
          {!isOnDesktop && (
            <button onClick={handleDesktopClick} className="menu-item">
              <span className="menu-item-icon">🖥️</span>
              <span>Desktop</span>
            </button>
          )}
          <button onClick={handleDeskSuiteClick} className="menu-item">
            <span className="menu-item-icon">📦</span>
            <span>Dashboard</span>
          </button>
          <button onClick={handleSettingsClick} className="menu-item">
            <span className="menu-item-icon">⚙️</span>
            <span>Settings</span>
          </button>
        </div>
      )}
    </>
  );
}

export default MenuButton;
